import React from 'react';
import { Box, Typography, TextField, Paper } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';
import { getCriteriaVariableLabel } from '../../../pages/ViewGoal/Insights/Criteria/utils/criteriaUtils';

const CriteriaFields = ({ 
  dataPoint, 
  index, 
  handleCriteriaChange 
}) => {
  if (!dataPoint.criteria || dataPoint.criteria.length === 0) {
    return null;
  }

  return (
    <Paper 
      elevation={1}
      sx={{ 
        p: 2, 
        mb: 2, 
        backgroundColor: 'transparent',
        border: '1px solid #e5e7eb',
        borderRadius: '8px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <TrendingUp sx={{ color: '#6b7280', mr: 1, fontSize: 18 }} />
        <Typography 
          variant='body1' 
          sx={{ 
            color: '#1f2937',
            fontWeight: 400,
            fontSize: '1rem'
          }}
        >
          Criteria
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {dataPoint?.criteria?.map((criteriaItem, criteriaIndex) => (
          <Box
            key={criteriaIndex}
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
              p: 1
            }}
          >
            <Typography 
              variant='body2' 
              sx={{ 
                color: '#1f2937',
                fontWeight: 400,
                minWidth: '45px'
              }}
            >
              Value:
            </Typography>
            <TextField
              type='text'
              inputProps={{
                'aria-label': `Criteria ${criteriaIndex + 1} value`,
                inputMode: 'numeric',
              }}
              margin='dense'
              size='small'
              value={criteriaItem.value || ''}
              sx={{ 
                width: '80px',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  '&:hover': {
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#6b7280',
                    }
                  },
                  '&.Mui-focused': {
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#6b7280',
                    }
                  }
                }
              }}
              onChange={(e) => {
                const newValue = e.target.value;
                if (newValue >= 0) {
                  handleCriteriaChange(index, criteriaIndex, newValue);
                }
              }}
            />

            <Typography 
              variant='body2'
              sx={{ 
                color: '#1f2937',
                fontWeight: 400
              }}
            >
              {(criteriaItem.MeasurementType ||
                criteriaItem.measurementType) === 'Frequency' &&
                'times of'}
              {(criteriaItem.MeasurementType ||
                criteriaItem.measurementType) === 'Duration' &&
                'minutes of'}
              {(criteriaItem.MeasurementType ||
                criteriaItem.measurementType) === 'Percentage' &&
                '% of'}
            </Typography>
            <Typography 
              variant='body2'
              sx={{ 
                color: '#1f2937',
                fontWeight: 500
              }}
            >
              {getCriteriaVariableLabel(criteriaItem)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default CriteriaFields;